import { IPersonalInfoCmsMobile } from '@vfit/consumer/data-access';
import { IConfigDocumentCms } from '@vfit/shared/models';

export const DEFAULT_CUSTOMER_REFERENCE = {
  nameTitle: [
    {
      rel: 'self',
      href: '/care/v1/nameTitle',
      id: 'EMPTY',
      name: 'EMPTY',
      displayName: ' ',
      default: true,
    },
    {
      rel: 'self',
      href: '/care/v1/nameTitle',
      id: 'Mr.',
      name: 'Mr.',
      displayName: 'Sig.',
      default: false,
    },
    {
      rel: 'self',
      href: '/care/v1/nameTitle',
      id: 'Mrs.',
      name: 'Mrs.',
      displayName: 'Sig.ra',
      default: false,
    },
    {
      rel: 'self',
      href: '/care/v1/nameTitle',
      id: 'Ms.',
      name: 'Ms.',
      displayName: 'Sig.na',
      default: false,
    },
    {
      rel: 'self',
      href: '/care/v1/nameTitle',
      id: 'Dr.',
      name: 'Dr.',
      displayName: 'Dr.',
      default: false,
    },
  ],
  identificationType: [
    {
      rel: 'self',
      href: '/care/v1/identificationType',
      id: '1',
      name: '1',
      displayName: "Carta d'identità",
      default: false,
    },
    {
      rel: 'self',
      href: '/care/v1/identificationType',
      id: '2',
      name: '2',
      displayName: 'Passaporto',
      default: false,
    },
    {
      rel: 'self',
      href: '/care/v1/identificationType',
      id: '3',
      name: '3',
      displayName: 'Patente di guida',
      default: false,
    },
  ],
};

export const organizeDocumentMobile = (
  documentIdCardCMS: IPersonalInfoCmsMobile,
  isRecognized: boolean
): IConfigDocumentCms => ({
  title: isRecognized
    ? documentIdCardCMS?.personalinfomobile?.clientLogged?.documentPreFilled?.title || ''
    : documentIdCardCMS?.personalinfomobile?.newDocument?.title || '',
  subtitle: isRecognized
    ? documentIdCardCMS?.personalinfomobile?.clientLogged?.documentPreFilled?.description ||
      ""
    : documentIdCardCMS?.personalinfomobile?.newDocument?.description ||
      "",
  docLable: documentIdCardCMS?.personalinfomobile?.selectInput?.docType || '',
  docNumberLable: documentIdCardCMS?.personalinfomobile?.selectInput?.docNumber || '',
  docExpirationDateLable:
    documentIdCardCMS?.personalinfomobile?.selectInput?.docExpirationDate || '',
  countryLable: documentIdCardCMS?.personalinfomobile?.selectInput?.nation || '',
  errorMessage: isRecognized
    ? documentIdCardCMS?.personalinfomobile?.clientLogged?.documentPreFilled
        ?.allFieldsAreRequired || ''
    : documentIdCardCMS?.personalinfomobile?.newDocument?.allFieldsAreRequired ||
      '',
  validationMessage: documentIdCardCMS?.personalinfomobile?.validationMessage || {},
});
